import { connect } from 'react-redux';
import { actions } from '../modules/Signup';
import { bindActionCreators } from 'redux';
import SignupView from '../components/SignupView';

const mapDispatchToProps = (dispatch) => ({
    dispatch,
    ...bindActionCreators(actions, dispatch)
});
 
const mapStateToProps = (state) => ({
    Signup: state.Signup,
    ListingState:state.ListingState,
    SelectState:state.selectState,
    AddListingState: state.AddListingState,
    auth:state.auth
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupView);


// WEBPACK FOOTER //
// ./src/routes/Signup/containers/SignupContainer.js